import { render, staticRenderFns } from "./ModattaSideModalNewOfferAudienceByProfileBasic.vue?vue&type=template&id=6dadfb62"
import script from "./ModattaSideModalNewOfferAudienceByProfileBasic.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalNewOfferAudienceByProfileBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports